class VisitedPageService {
    getPages(isSession?: boolean): string[] {
        if (typeof window !== "undefined") {
            return isSession ? JSON.parse(sessionStorage.getItem("visited_page")) : JSON.parse(localStorage.getItem("visited_page"))
        }
    }
    visited(page: string, isSession?: boolean): boolean {
        if (typeof window !== "undefined") {
            if (isSession ? sessionStorage.getItem("visited_page") : localStorage.getItem("visited_page")) {
                const currentPages: string[] = JSON.parse(isSession ? sessionStorage.getItem("visited_page") : localStorage.getItem("visited_page"))

                if (currentPages.includes(page)) return true
                else return false
            } else return false
        }
    }
    setPage(page: string, isSession?: boolean) {
        if (typeof window !== "undefined") {
            const currentPages: string[] = JSON.parse(isSession ? sessionStorage.getItem("visited_page") : localStorage.getItem("visited_page")) ?? [];
            currentPages.push(page)

            if (isSession) sessionStorage.setItem("visited_page", JSON.stringify(currentPages))
            else localStorage.setItem("visited_page", JSON.stringify(currentPages))
        }
    }
}
export default new VisitedPageService();